import React from "react";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import FAQElement from "components/FAQ";

const FAQs = () => {
  const FAQdata = [
    {
      q: "Is there a free trial available?",
      a: "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
    },
    {
      q: "Can I change my plan later?",
      a: ""
    },
    {
      q: "What is your cancellation policy?",
      a: ""
    },
    {
      q: "Can other info be added to an invoice?",
      a: ""
    },
    {
      q: "How does billing work?",
      a: ""
    }
  ];
  return (
    <Container>
      <Typography
        color={Colors.white300}
        size="3.6rem"
        weight="semibold"
        align="center"
        m_size="4xl"
      >
        Frequently asked questions
      </Typography>
      <Typography
        color={Colors.grey600}
        size="2xl"
        m_size="lg"
        mt="2"
        align="center"
      >
        Everything you need to know about the product and billing.
      </Typography>
      <Items>
        {FAQdata.map(({ q, a }, i) => {
          return (
            <Item key={i}>
              <FAQElement q={q} a={a} />
            </Item>
          );
        })}
      </Items>
    </Container>
  );
};

export default FAQs;

const Container = styled.div`
  margin-top: 8rem;
  padding-bottom: 20rem;
  z-index: 100;
  position: relative;
`;

const Items = styled.div`
  margin-top: 6.8rem;
  width: 65%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-top: 3.2rem;
  }
`;
const Item = styled.div`
  margin-bottom: 3.2rem;
  width: 100%;
`;
